import { FlaskConical } from "lucide-react";
import { Modal, ModalFooter, Button } from "@/components/ui";

interface DemoRestrictionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function DemoRestrictionModal({
  isOpen,
  onClose,
}: DemoRestrictionModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Tryb demo"
      size="sm"
      closeOnOverlayClick
    >
      <div className="flex flex-col items-center text-center gap-4 py-2">
        <div className="flex items-center justify-center w-14 h-14 rounded-full bg-amber-100 dark:bg-amber-900/30">
          <FlaskConical className="w-7 h-7 text-amber-600 dark:text-amber-400" />
        </div>
        <p className="text-muted-foreground">
          Ta operacja nie jest dostępna w wersji demo. Aby korzystać z pełnej
          funkcjonalności, dołącz do nas {" "}
          <a
            href="https://beeintime.pl"
            className="text-primary hover:underline font-medium"
          >
            https://beeintime.pl
          </a>
        </p>
      </div>
      <ModalFooter>
        <Button variant="outline" onClick={onClose}>
          Zamknij
        </Button>
      </ModalFooter>
    </Modal>
  );
}
